import { render, staticRenderFns } from "./PersonLabel.vue?vue&type=template&id=3fbffbe8"
import script from "./PersonLabel.vue?vue&type=script&lang=js"
export * from "./PersonLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports